import React from 'react';
import './Patterns.css';

export type NoticeTone = 'info' | 'warn' | 'danger' | 'success';

export interface NoticeProps {
  tone: NoticeTone;
  children: React.ReactNode;
  /** Right-aligned slot — e.g. a Reload/Update button beside the message. */
  action?: React.ReactNode;
  /** Override the tone-derived role. Default: info/success -> 'status', warn/danger -> 'alert'. */
  role?: 'alert' | 'status';
  testId?: string;
  /** Optional spacing/layout utility classes (e.g. "mb-3") applied to the root element. */
  className?: string;
}

const DEFAULT_ROLE: Record<NoticeTone, 'alert' | 'status'> = {
  info: 'status',
  success: 'status',
  warn: 'alert',
  danger: 'alert',
};

/**
 * Inline message primitive (info/warn/danger/success). Distinct from:
 *   <AlertCard> — dashboard count-card; <Banner> — sync/offline status banner.
 */
export const Notice: React.FC<NoticeProps> = ({ tone, children, action, role, testId, className }) => (
  <div
    data-testid={testId ?? 'notice'}
    role={role ?? DEFAULT_ROLE[tone]}
    className={['pat-notice', `pat-notice--${tone}`, className].filter(Boolean).join(' ')}
  >
    {children}
    {action}
  </div>
);
